import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiCallsV2 } from '../../../api/apiV2';
import { PeriodDataDto, SubmitTimesheetDto } from '../../../api/generated/v2/generated/data-contracts';
import { USER_PERIOD_BY_DATE } from '../../../constants/queryKeys';
import { useGridStore } from '../state';
import { useInitialData } from '../../../hooks/useInitialData';

// Wait for the Fluent dialog fade-out before showing the checkmark
const DIALOG_FADE_MS = 300;

export const useSubmitTimesheet = () => {
    const queryClient = useQueryClient();
    const {
        data: { aggregatedUser },
    } = useInitialData();
    const autoApprove = aggregatedUser.user?.autoApprove === true;

    return useMutation({
        mutationFn: (dto: SubmitTimesheetDto) => ApiCallsV2.submitTimesheet(dto),
        onSuccess: () => {
            const nextState = autoApprove ? 'Approved' : 'Submitted';

            queryClient.setQueriesData<PeriodDataDto>({ queryKey: [USER_PERIOD_BY_DATE] }, old => (old ? { ...old, timesheetState: nextState } : old));

            const store = useGridStore.getState();
            store.setPeriodData(prev => (prev ? { ...prev, timesheetState: nextState } : prev));
            setTimeout(() => useGridStore.getState().setShowSubmitSuccess(true), DIALOG_FADE_MS);
        },
    });
};
